__turbopack_context__.v({
  "closed": "LocationStatus-module-scss-module__gLmx9W__closed",
  "loading": "LocationStatus-module-scss-module__gLmx9W__loading",
  "open": "LocationStatus-module-scss-module__gLmx9W__open",
  "pill": "LocationStatus-module-scss-module__gLmx9W__pill",
});
